import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.Landscaping;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "Landscaping.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "Landscaping.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "Landscaping.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/LandscapingGame/scenes/IntroductionScene.ts